import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles(theme => ({
  root: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    // height: 30,
    // borderRadius: 20,
  },
  reactSwitch: {
    cursor: "pointer",
    width: 70,
    height: 30,
    background: "#F2F2F2",
    borderRadius: 20,
    position: "relative",
    transition: " background-color 0.2s",
  },

  reactSwitchBtn: {
    position: "absolute",
    zIndex: 1,
    top: 0,
    left: 0,
    width: 36,
    height: 30,
    borderRadius: 20,
    transition: '.2s',
    background: '#FFFFFF',
    boxShadow: "0px 1px 3px #00000029",
  },
  reactSwitchCheckBox: {
    height: 0,
    width: 0,
    position: "absolute",
    visibility: "hidden",
    "&:checked": {
      "& + $reactSwitchBtn": {
        left: "calc(100% - 2px)",
        transform: "translateX(-100%)"
      }
    }
  },

  reactSwitchLabel: {
    // position: "relative",
    // zIndex: 0,
    height: "100%",
    "& span": {
      position: "absolute",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      width: "53%",
      height: "100%",
      zIndex: 1,
      "&:first-child": {
        left: 0
      },
      "&:last-child": {
        right: 0
      },
    }
  },
  activeIcon: {
    "& img": {
      filter: 'invert(27%) sepia(51%) saturate(2878%) hue-rotate(346deg) brightness(104%) contrast(97%) !important'
    }
  }
}));

export default useStyles;
